<template>
  <v-card flat class="text-center">
    <v-toolbar flat>
      <v-spacer />
      <h2 class="text-center">Login</h2>
      <v-spacer />
    </v-toolbar>
    <v-card-text>
      <v-form ref="signinForm">
        <div class="form-group">
          <v-text-field
            outlined
            dense
            label="Email"
            type="email"
            v-model="email"
            :rules="emailRules"
          />
        </div>
        <div class="form-group">
          <v-text-field
            id="password"
            label="Password"
            outlined
            type="password"
            :rules="passwordRules"
            v-model="password"
            dense
          />
        </div>
        <div class="form-group">
          <v-btn
            color="primary"
            @click="login"
            :loading="isSubmitting"
            :disabled="isSubmitting"
            >Login</v-btn
          >
        </div>
      </v-form>

      <!-- <div class="social-login-divider">
        <span>or</span>
      </div>

      <div class="social-login-buttons">
        <v-btn
          block
          outlined
          large
          class="social-btn google-btn mb-3"
        >
          <v-icon left color="#DB4437">mdi-google</v-icon>
          <span>Continue with Google</span>
        </v-btn>
        <v-btn
          block
          dark
          large
          class="social-btn apple-btn"
          color="#000000"
        >
          <v-icon left>mdi-apple</v-icon>
          <span>Continue with Apple</span>
        </v-btn>
      </div> -->

      <div class="mb-5 mt-5">
        <small
          @click="$router.push('/forgot-password')"
          class="font-weight-bold"
          >Forgot password?</small
        >
      </div>

      <!-- Mobile/Cordova only message at bottom -->
      <v-divider v-if="isCordova" class="my-6" />

      <div v-if="isCordova" class="mobile-web-signup-note">
        <div class="text-body-2 font-weight-bold primary--text mb-1">
          Create your account on the website
        </div>

        <div class="text-body-2">
          For security reasons, sign up is available on
          <span class="font-weight-bold">app.thedriverx.com</span>. After
          creating your account, come back here and log in.
        </div>

        <v-btn
          class="mt-4"
          color="primary"
          block
          depressed
          @click="openWebsiteSignup"
        >
          Open the website
        </v-btn>
      </div>

      <div class="mb-3 mt-3 signup-row">
        <span class="d-none d-sm-inline-block">Don't have an account??</span
        ><br />
        <span
          role="button"
          tabindex="0"
          v-if="!isCordova"
          class="signup-link primary--text font-weight-bold"
          @click.stop="goToSignup"
          @touchend.stop.prevent="goToSignup"
          @keydown.enter.prevent="goToSignup"
          @keydown.space.prevent="goToSignup"
          >Signup</span
        >
      </div>
      <!-- <social-signin
        :signinSocial="signinSocial"
        :userTypeDialog="userTypeDialog"
        :fbLoading="fbLoading"
        :goLoading="goLoading"
        :appleLoading="appleLoading"
      />-->
      <!-- Add these test buttons after the Signup button (around line 27) -->
      <!-- <div class="test-buttons mt-5 pa-3" style="background: #f5f5f5; border-radius: 8px;">
        <p class="text-center mb-2"><small>🧪 Test Browser Links:</small></p>
        <v-btn small color="info" @click="testGoogle" block class="mb-2">
          Test TheDriverX
        </v-btn>
        <v-btn small color="warning" @click="testStripe" block>
          Test Stripe
        </v-btn>
      </div> -->
    </v-card-text>

    <!--  Payment Success Modal -->
    <v-dialog v-model="showSuccessModal" max-width="400">
      <v-card>
        <v-card-title class="headline d-flex justify-center text-center"
          >Congratulations!</v-card-title
        >
        <v-card-text class="text-center">
          Payment Success!
          <p>Please login to continue.</p>
        </v-card-text>
        <v-card-actions class="d-flex justify-center">
          <v-btn color="primary" @click="closeSuccessModal">OK</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!--    <v-toolbar flat class="hidden-sm-and-up">
      <v-spacer />
      <router-link to="/">
        <img
          alt="logo"
          :src="require('@/assets/img/logo-black.png')"
          width="120"
        />
      </router-link>
      <v-spacer />
    </v-toolbar>-->
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Parse from "parse";
import validationRules from "@/validation-rules";
import axios from "axios";
import { loadStripe } from "@stripe/stripe-js";
const hello = require("hellojs/dist/hello.all.min.js");

export default {
  // components: { SocialSignin },
  data() {
    return {
      userTypeDialog: false,
      isSubmitting: false,
      fbLoading: false,
      goLoading: false,
      appleLoading: false,
      email: "",
      password: "",
      showSuccessModal: false,
      ...validationRules,
    };
  },
  computed: {
    ...mapGetters(["isLogged", "user"]),
    isCordova() {
      return typeof window !== "undefined" && !!window.cordova;
    },
  },

  watch: {
    isLogged() {
      if (this.isLogged) {
        const userType = localStorage.getItem("userType");
        const redirectPath =
          this.$route.query.redirect || userType === "student"
            ? "/student-dashboard"
            : "/dashboard";
        this.$router.push(redirectPath);
      }
    },
  },
  methods: {
    ...mapActions(["getUser", "toggleDialog", "toggleTour", "updateUser"]),

    goToSignup() {
      this.$router.push({ name: "Signup" });
    },

    openWebsiteSignup() {

      // local url for testing
      // const url = "http://localhost:8080";
      // live url
      const url = "https://app.thedriverx.com";
      // Cordova-friendly: open system browser
      window.cordova.InAppBrowser.open(url, "_system", "location=yes");
    },

    // code to for testing and delete after testing starting

    // SIMPLE TEST METHODS (No plugin needed):
    testGoogle() {
      const url = "https://thedriverx.com";
      // const url = 'https://stage.thedriverx.appscorridor.com'
      // const url = 'http://localhost:1337'
      console.log("🧪 Test 1: Opening URL:", url);

      try {
        // iOS 18+: Simple window.open with _blank (no third parameter!)
        const opened = window.open(url, "_blank");

        console.log("Window.open returned:", opened);
      } catch (error) {
        console.error("❌ Error:", error);
        alert("❌ Error: " + error.message);
      }
    },

    async testStripe() {
      alert("🧪 Creating test Stripe checkout...");

      try {
        const response = await axios.post(
          "/create-checkout-session",
          {
            name: "Test Package",
            price: 100,
            packageId: "test123",
            userId: "test-user",
            schoolId: "test-school",
            prePaid: false,
            email: "test@example.com",
            priceId: null,
          },
          {
            headers: {
              "X-Parse-Application-Id":
                "71237DFB8FA1D83A3363EB45CF0B4AC7BD44E1EA",
            },
          },
        );

        const sessionId = response.data.id;
        const checkoutUrl =
          response.data.url || `https://checkout.stripe.com/c/pay/${sessionId}`;

        console.log("🧾 Session ID:", sessionId);
        console.log("🔗 Checkout URL:", checkoutUrl);

        alert(`✅ Session created!\nID: ${sessionId}\n\nOpening checkout...`);

        // iOS 18+: Simple window.open
        window.open(checkoutUrl, "_blank");

        setTimeout(() => {
          alert("✅ Checkout URL opened! Check if Safari launched.");
        }, 100);
      } catch (error) {
        console.error("❌ Test error:", error);
        alert("❌ Test failed: " + error.message);
      }
    },
    // code to for testing and delete after testing ending

    login() {
      this.isSubmitting = true;
      const self = this;
      if (self.$refs.signinForm.validate()) {
        Parse.User.logIn(self.email, self.password)
          .then(async () => {
            const currentUser = Parse.User.current();
            console.log(
              "currentUser  pre paid = ",
              currentUser.get("pre_paid"),
            );
            console.log(
              "currentUser  packageId = ",
              currentUser.get("packageId"),
            );
            const prePaid = currentUser.get("pre_paid");
            const packageId = currentUser.get("packageId");
            if (!prePaid && packageId) {
              const isMobileApp = typeof window.cordova !== "undefined";
              if (isMobileApp) {
                localStorage.clear();
                Parse.User.logOut();
                self.isSubmitting = false;
                self.toggleDialog({
                  status: true,
                  title: "Payment Required",
                  message:
                    "Please go to www.thedriverx.com and login again to complete the payment steps.",
                });
              } else {
                const packageData = await this.fetchPackageData(packageId);
                console.log("packageData come == ", packageData?.title);

                // If a discount is still active on this package, use the discounted
                // price; otherwise fall back to the regular stored price.
                const effectivePrice = this.resolveEffectivePrice(packageData);
                console.log(
                  "resolved checkout price (discount-aware):",
                  effectivePrice,
                  "raw price:",
                  packageData?.price
                );

                localStorage.clear();
                Parse.User.logOut();
                await this.handleCheckout({
                  name: packageData?.title,
                  price: effectivePrice,
                  packageId: packageData?.price,
                  userId: currentUser.id,
                  schoolId: packageData?.schoolId?.objectId,
                  prePaid: packageData?.prePaid,
                  email: currentUser.get("email"),
                  priceId: currentUser.get("subscriptionId") || "",
                  taxApplicable: packageData?.taxApplicable,
                });
                self.isSubmitting = false;
              }
            } else {
              var query = new Parse.Query(Parse.Role);
              query.containedIn("name", ["Instructor", "Student"]);
              query.equalTo("users", Parse.User.current());
              query.first().then(function (role) {
                if (!currentUser.get("status")) {
                  self.toggleDialog({
                    status: true,
                    title: "Warning",
                    message: "Your account status pending.",
                  });
                }
                self.toggleTour(currentUser.get("tourFinished"));
                if (!role) {
                  localStorage.clear();
                  Parse.User.logOut();
                  self.alertMessage = "No role found";
                  self.toggleDialog({
                    status: true,
                    title: self.errorType,
                    message: self.alertMessage,
                  });
                  self.isSubmitting = false;
                } else {
                  const userType = role.get("name").toLowerCase().trim();
                  localStorage.setItem("userType", userType);
                  self.isSubmitting = false;
                  self.getUser();

                  const redirectPath = self.$route.query.redirect;
                  console.log("User login succes - ", redirectPath);
                  setTimeout(() => {
                    if (redirectPath) {
                      self.$router.push(redirectPath);
                    } else if (userType === "student") {
                      if (self.user.get("getStartedDone")) {
                        // self.$router.push({ name: "StudentDashboard" });
                      } else {
                        this.$router.push({ name: "StudentDashboard" });
                        /** In case of Pre-paid packagee purchase
                         * Disabling the Get Started Page
                         */
                        // self.$router.push({ name: 'GetStarted' })
                      }
                    } else {
                      // self.$router.push({ name: "Dashboard" });
                    }
                  });
                }
              });
            }
          })
          .catch(function (e) {
            self.alertMessage = e.message;
            self.toggleDialog({
              status: true,
              title: "Error",
              message: self.alertMessage,
            });
            self.isSubmitting = false;
          });
      }
    },

    closeSuccessModal() {
      this.showSuccessModal = false;
    },

    async fetchPackageData(packageId) {
      const SchoolPackages = Parse.Object.extend("SchoolPackages");
      const query = new Parse.Query(SchoolPackages);

      // Assuming packageId is a unique identifier in the collection
      query.equalTo("objectId", packageId);

      try {
        const result = await query.first();
        return result ? result.toJSON() : null;
      } catch (error) {
        console.error("Error while fetching package data:", error);
        return null;
      }
    },
    resolveEffectivePrice(pkg) {
      // Mirrors the discount logic used by PackagePlanBoxes / getAllSchoolPackages:
      // if `discountPrice` and `discountEnd` are set AND discountEnd is still in the
      // future, the user pays the discounted price. Otherwise the regular `price`.
      if (!pkg) return 0;
      const end = pkg.discountEnd;
      let endMs = 0;
      if (end) {
        if (end instanceof Date) endMs = end.getTime();
        else if (typeof end === "number") endMs = end;
        else if (typeof end === "string") endMs = new Date(end).getTime();
        else if (end.iso) endMs = new Date(end.iso).getTime();
      }
      const hasDiscount =
        pkg.discountPrice != null &&
        pkg.discountPrice > 0 &&
        endMs > Date.now();
      return hasDiscount ? pkg.discountPrice : pkg.price;
    },
    async handleCheckout({
      name,
      price,
      packageId,
      userId,
      schoolId,
      prePaid,
      email,
      priceId,
      taxApplicable,
    }) {
      try {
        console.log("Calling Checkout Session API email  - ", email);
        console.log(
          "Calling Checkout Session API taxApplicable  - ",
          taxApplicable,
        );
        console.log("Calling Checkout Session API price  - ", price);
        // Make a request to your backend to create a checkout session
        if (taxApplicable) {
          price = price + price * 0.13;
        }
        const response = await axios.post(
          /** Adding 13% Ontario Tax on the Price of Package  */
          "/create-checkout-session",
          { name, price, packageId, userId, schoolId, prePaid, email, priceId },
          {
            headers: {
              "X-Parse-Application-Id":
                "71237DFB8FA1D83A3363EB45CF0B4AC7BD44E1EA",
            },
          },
        );

        console.log(
          "Calling Checkout Session API response ===  ",
          response.data,
        );
        const sessionId = response.data.id;
        if (sessionId) {
          console.log("session id ===", sessionId);

          const checkoutUrl =
            response.data.url ||
            `https://checkout.stripe.com/c/pay/${sessionId}`;

          console.log("🔗 Checkout URL:", checkoutUrl);

          // Check if running on mobile (Cordova)
          if (typeof window.cordova !== "undefined") {
            console.log("📱 Mobile: Opening checkout in Safari");

            // Mobile: Simple window.open (same as test buttons)
            window.open(checkoutUrl, "_blank");

            return;
          }

          // Web: Use Stripe.js redirect
          console.log("🌐 Web: Using Stripe.js redirect");

          const PUBLISHABLE_KEY = "pk_live_51Hca9mL9XL9PNUheZERE3glh8mHxefAHqRy4MOcTQE5irYCbhkOHGXx8Nk7Tcr51dMnS01RUA0JJUDs8UbvYlp0b00SLCtH4Lk";

          // const PUBLISHABLE_KEY = 'pk_test_51Hca9mL9XL9PNUhe1FYfznWfUIlyz3IljTmx9etbCin5rUPgvyQLO6QXOyuke5Job8PtBHCZ3y72uULizi2ZNveL00NjBgKKjQ'

          const stripe = await loadStripe(PUBLISHABLE_KEY);
          await stripe.redirectToCheckout({ sessionId });

          return;
        }
      } catch (error) {
        console.error("Error creating Stripe checkout session:", error);
      }
    },
    async signinSocialWeb(network) {
      hello(network)
        .login()
        .then(() => {
          const authRes = hello(network).getAuthResponse();
          this.access_token = authRes.access_token;
          /*
            performs operations using the token from authRes
          */
          hello(network)
            .api("me", {
              scope: "email",
              force: true,
            })
            .then((json) => {
              console.log(json);
              const profile = json;
              const id = profile.id;
              const email = profile.email;
              const firstName = profile.first_name || "";
              const lastName = profile.last_name || "";
              const thumbnail = profile.thumbnail || "";
              let myAuthData = {};
              if (network === "google") {
                this.goLoading = true;
                myAuthData = {
                  id: id,
                  access_token: this.access_token,
                };
              } else if (network === "facebook") {
                this.fbLoading = true;
                myAuthData = {
                  access_token: this.access_token,
                  id: profile.id, // Required field. Used to uniquely identify the linked account.
                };
              }
              this.loginWith(
                myAuthData,
                id,
                firstName,
                lastName,
                email,
                thumbnail,
              );
            });
        });
    },
    async signinSocialMobile(network) {
      if (network === "facebook") {
        this.fbLoading = true;
        window.facebookConnectPlugin.login(
          ["public_profile", "email"],
          this.fbLoginSuccess,
          function loginError(error) {
            console.log(error);
            this.fbLoading = false;
            this.toggleDialog({
              status: true,
              title: "Error",
              message: "Something went wrong, please try again.",
            });
          },
        );
      } else if (network === "apple") {
        this.appleLoading = true;
        window.cordova.plugins.SignInWithApple.signin(
          { requestedScopes: [0, 1] },
          (obj) => {
            const id = obj.user;
            const email = obj.email;
            const firstName = obj.fullName.givenName || "";
            const lastName = obj.fullName.familyName || "";

            const myAuthData = {
              access_token: obj.identityToken,
              id: id, // Required field. Used to uniquely identify the linked account.
            };
            this.loginWith(myAuthData, id, firstName, lastName, email);
          },
          (err) => {
            this.appleLoading = false;
            console.log("error: " + err);
            this.toggleDialog({
              status: true,
              title: "Error",
              message: "Something went wrong, please try again.",
            });
          },
        );
      } else {
        /** Android */
        this.goLoading = true;
        window.plugins.googleplus.login(
          {
            scopes:
              "https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile", // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
            webClientId:
              "814141650586-bkibmuvli7b2o5kqaq0itdqrlm3omdv9.apps.googleusercontent.com", // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
            offline: true, // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
          },
          (obj) => {
            console.log(obj);
            const id = obj.userId;
            const email = obj.email;
            const firstName = obj.givenName || "";
            const lastName = obj.familyName || "";
            const thumbnail = obj.thumbnail || "";

            const myAuthData = {
              access_token: obj.accessToken,
              id: id, // Required field. Used to uniquely identify the linked account.
            };
            this.loginWith(
              myAuthData,
              id,
              firstName,
              lastName,
              email,
              thumbnail,
            );
          },
          (msg) => {
            this.goLoading = false;
            console.log("error: " + msg);
            this.toggleDialog({
              status: true,
              title: "Error",
              message: "Something went wrong, please try again.",
            });
          },
        );
      }
    },
    async fbLoginSuccess(userData) {
      alert(JSON.stringify(userData));
      this.fbLoading = false;
      await window.facebookConnectPlugin.getAccessToken((token) => {
        console.log(token);
        /** Get users information */
        window.facebookConnectPlugin.api("/me", function (me) {
          console.log(me);
          alert("Verification is yet to be done");
          // this.fbLoading = false;
          // alert(JSON.stringify(me));
        });

        // window.facebookConnectPlugin.api(
        //   "/me?fields=id,name,email",
        //   ["public_profile", "email"],
        //   (response) => {
        //     alert("Success");
        //     alert(
        //       response.id +
        //         " | " +
        //         response.name +
        //         " | " +
        //         response.email +
        //         " | "
        //     );
        //     let email = "";
        //     let firstName = "";
        //     let lastName = "";
        //     let id = userData.authResponse.userID;

        //     let myAuthData = {};
        //     myAuthData = {
        //       access_token: token,
        //       id: id, // Required field. Used to uniquely identify the linked account.
        //     };
        //     this.loginWith(myAuthData, id, firstName, lastName, email);
        //   },
        //   (error) => {
        //     alert(JSON.stringify(error));
        //     console.log(error);
        //     this.goLoading = false;
        //     this.fbLoading = false;
        //   }
        // );
      });
    },
    /** Social log in */
    async loginWith(authData, id, firstName, lastName, email, thumbnail) {
      const provider = {
        authenticate: (options) => {
          // Some code to get retrieve authData
          // If retrieved valid authData, call success function with the data
          options.success(this, {
            id: id,
          });
          // You can also handle error
          options.error(this, {});
        },
        restoreAuthentication() {
          return true;
        },

        getAuthType() {
          return "socialAuth";
        },

        getAuthData() {
          return {
            authData,
          };
        },
      };

      Parse.User._registerAuthenticationProvider(provider);
      const user = new Parse.User();
      await user.linkWith(provider.getAuthType(), provider.getAuthData()).then(
        async () => {
          const currentUser = Parse.User.current();
          /** we should not update them but insert them for the first time, since we have option to change password and email */
          if (
            typeof currentUser.get("email") === "undefined" ||
            currentUser.get("email") === ""
          ) {
            await this.updateUser({
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: email,
              emailVerified: true,
              customEmail: email,
              profilePicture: thumbnail,
              profileNotCompleted: true,
              status: true,
            });

            const nData = {
              firstName: firstName,
              lastName: lastName,
              email: email,
              username: email,
              customEmail: email,
              profilePicture: thumbnail,
              profileNotCompleted: true,
              status: true,
              user: currentUser.id,
            };

            await Parse.Cloud.run("updateUser", nData).then(
              (res) => {
                console.log(res);
              },
              (error) => {
                console.log(error);
              },
            );

            if (email !== "") {
              /** Add contact to mailgun */
              const cData = {
                firstName: firstName,
                lastName: lastName,
                email: email,
                phone: "",
              };

              Parse.Cloud.run("addContactToMailChimp", cData).then(
                (res) => {
                  console.log(res);
                },
                (error) => {
                  console.log(error);
                },
              );
            }

            /** for now, put them in pending status until we figure out  how to handle to roles and rest of the profile */
            const data = {
              user: currentUser.id,
              accountname: "Pending",
              admin: false,
            };

            await Parse.Cloud.run("addUserToRole", data).then(() => {
              setTimeout(() => {
                this.fbLoading = false;
                this.goLoading = false;
                this.appleLoading = false;
                // const redirectPath = "/get-started";
                // this.$router.push(redirectPath);
                /** Ask them to select a type of user */
                this.userTypeDialog = true;
              }, 2000);
            });
          } else {
            const currentUser = Parse.User.current();
            var query = new Parse.Query(Parse.Role);
            query.containedIn("name", ["Instructor", "Student"]);
            query.equalTo("users", Parse.User.current());
            query.first().then(async (role) => {
              if (currentUser.get("status")) {
                if (!role) {
                  /** it might be the case that the social logged in user didn't complete userType and this is
                   * why on 2nd log in they are here. So they need to complete their selection
                   */
                  // localStorage.clear();
                  // Parse.User.logOut();
                  // this.alertMessage = "You are not authorized to login";
                  // this.toggleDialog({
                  //   status: true,
                  //   title: this.errorType,
                  //   message: this.alertMessage,
                  // });
                  this.userTypeDialog = true;
                } else {
                  const userType = role.get("name").toLowerCase().trim();
                  console.log(userType);
                  localStorage.setItem("userType", userType);
                  await this.getUser();
                }
              } else {
                this.alertMessage = "Your account has been disabled";
                this.toggleDialog({
                  status: true,
                  title: this.errorType,
                  message: this.alertMessage,
                });
                Parse.User.logOut();
              }
            });
          }
        },
        (error) => {
          console.log(error);
          this.alertMessage = "Something went wrong, please try again";
          this.toggleDialog({
            status: true,
            title: this.errorType,
            message: this.alertMessage,
          });
        },
      );
    },

    async signinSocial(network) {
      console.log({ network });
      if (typeof window.device !== "undefined") {
        this.signinSocialMobile(network);
      } else {
        this.signinSocialWeb(network);
      }
    },
  },
  async created() {
    const payment = this.$route.query.payment;
    console.log("Geeitng Payment on Page load = ", payment);
    if (payment === "success") {
      this.showSuccessModal = true;
    }
  },
};
</script>

<style scoped>
.mobile-web-signup-note {
  border: 1px solid rgba(255, 255, 255, 0.14);
  background: rgba(0, 0, 0, 0.12);
  border-radius: 12px;
  padding: 14px;
  text-align: left;
}

.signup-row {
  position: relative;
  z-index: 10;
  isolation: isolate;
}
.signup-link {
  display: inline-block;
  text-decoration: none;
  padding: 8px 16px;
  min-height: 44px;
  line-height: 28px;
  box-sizing: border-box;
  -webkit-tap-highlight-color: transparent;
  touch-action: manipulation;
  cursor: pointer;
  user-select: none;
}
.signup-link:hover,
.signup-link:active,
.signup-link:focus {
  text-decoration: none;
  opacity: 0.9;
}

.social-login-divider {
  display: flex;
  align-items: center;
  text-align: center;
  margin: 20px 0 16px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 13px;
}
.social-login-divider::before,
.social-login-divider::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.social-login-divider span {
  padding: 0 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.social-login-buttons {
  display: flex;
  flex-direction: column;
}
.social-btn {
  text-transform: none !important;
  font-weight: 500 !important;
  letter-spacing: 0 !important;
  border-radius: 8px !important;
}
.social-btn .social-icon {
  width: 20px;
  height: 20px;
  margin-right: 10px;
}
.google-btn {
  background-color: #ffffff !important;
  color: rgba(0, 0, 0, 0.75) !important;
  border-color: rgba(0, 0, 0, 0.2) !important;
}
.apple-btn {
  color: #ffffff !important;
}
</style>
